export default __webpack_public_path__ + "locales/pt/ChangeUserStatusDialog.json?hash=d00232c20eebb660cda96e728a2e23de";